import { Nacionalidade } from 'src/tipos'

export const SELECT_NACIONALIDADES = [
  { id: Nacionalidade[Nacionalidade.brasileira], texto: 'Brasileira' },
  { id: Nacionalidade[Nacionalidade.outra], texto: 'Outra' }
]
